export default __webpack_public_path__ + "static/media/499.45bf6431.png";